import React, { useCallback } from "react";
import csn from "classnames";
import css from "./index.m.less";
import { openUrlInNewTab } from "utils/commons";
import { STREAMER_TYPE, useWebConfig } from "utils/webConfig";
import { RouteUtils } from "utils/RouteUtils";
import { FromName } from "landings/Analytics/EventName";
import { history } from "utils/History";
export const TrialFundBanner = () => {
    const { home: _home } = useWebConfig();

    const home = _home?.streamer?.[PLATFORM._CODE] as STREAMER_TYPE;

    const handleCallback = useCallback(() => {
        if (home?.link) {
            openUrlInNewTab(RouteUtils.appendParams(home.link, { from: FromName.home_streamer }));
        }
    }, [home?.link]);
    if (!home?.enabled) return null;

    return (
        <div className={csn(css.container)}>
            <span>{home?.title || ""}</span>
            {home?.btn && (
                <div onClick={handleCallback} className={css.button}>
                    {home?.btn}
                </div>
            )}
        </div>
    );
};

export const KYCBanner = () => {
    const handleCallback = useCallback(() => {
        history.push("/account/kyc");
    }, []);

    return (
        <div className={csn(css.container)}>
            <span>Complete the identity verification and make a deposit to win 15 USDT.</span>
            <div onClick={handleCallback} className={css.button}>
                Identify Verification
            </div>
        </div>
    );
};
